var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartnership = function SvgPartnership(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#partnership_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.938a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5m0-2.625a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75M10.5 3.938a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5m0-2.625a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75M11.375 13.125h-1.75a.875.875 0 0 1-.875-.875V9.188h.875v3.062h1.75V8.313h.875V5.687a.44.44 0 0 0-.437-.437h-2.81L7 8.75l-2.004-3.5H2.187a.437.437 0 0 0-.437.438v2.625h.875v3.937h1.75V9.188h.875v3.062a.875.875 0 0 1-.875.875h-1.75a.875.875 0 0 1-.875-.875V9.188a.875.875 0 0 1-.875-.876V5.688a1.313 1.313 0 0 1 1.313-1.313h3.316L7 7l1.496-2.625h3.316a1.313 1.313 0 0 1 1.313 1.313v2.625a.875.875 0 0 1-.875.874v3.063a.875.875 0 0 1-.875.875"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "partnership_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgPartnership;